import { NAMESPACE, CLOSE_PRIMARY_NAVIGATION } from '../store/sitewide';

export default function({ store }) {
  if (process.server) {
    return true;
  }

  return store.dispatch(`${NAMESPACE}/${CLOSE_PRIMARY_NAVIGATION}`);
}
